import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Update Course presentational image
 * @param course_id
 * @param version
 * @param contentId
 * @param abortController
 */
const updateCoursePresentationalImage = (
  course_id: string,
  version: number,
  contentId: string,
  abortController: AbortController
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL =
      routes.COURSE + course_id + '/' + version + '/presentational-photo'
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
      signal: abortController.signal,
    }
    const data = { contentId }

    AxiosClient.post(URL, data, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default updateCoursePresentationalImage
